/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { CharacterCounterProps } from './index';
import { getTextColor } from './style-helpers';

/**
 * Base styles for the character counter
 *
 * @param {CharacterCounterProps} props The character counter properties object
 * */
/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = ({ count, max }: CharacterCounterProps) => css`
    ${theme.typography.body_small};
    margin: 0.4rem 0;
    color: ${getTextColor(count, max)};
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * The character counter styles
 *
 * @param {CharacterCounterProps} props The character counter properties object
 * */
export const styles = (props: CharacterCounterProps) => css`
    ${baseStyles(props)}
`;
